// 营销首页
import { useEffect, useRef, useState } from 'react'
import { useMount } from 'ahooks'
import { routesMap, utils, uploadEt } from '@/utils'
import { useCorpInfoStore } from '@/stores'
import { useNavigate } from 'react-router-dom'
import apis from '@/apis'
import type { ModuleItemProps } from '@/types/interfaces'
import { Toast } from 'antd-mobile'
import styles from './Home.module.less'
import Banner from './components/Banner/Banner'
import Nav1 from './components/Nav1/Nav1'
import Nav2 from './components/Nav2/Nav2'
import ProductModule from './components/ProductModule/ProductModule'
import SearchBar from '@/components/SearchBar/Index'
import AllProducts from './components/AllProducts/AllProducts'
import i18n from '@/utils/i18n'
import BannerDefault from './components/Banner/BannerDefault'

const { to } = utils
const { corpApi } = apis
const { t } = i18n

function Home() {
  const { corpInfo } = useCorpInfoStore()
  const { corpId } = corpInfo
  const navigate = useNavigate()
  const [modules, setModules] = useState<ModuleItemProps[]>([])
  const searchBarDom = useRef<HTMLDivElement>(null)
  const [searchBarHeight, setSearchBarHeight] = useState(0)
  const [isLoadingProducts, setIsLoadingProducts] = useState(false)

  useMount(async () => {
    uploadEt({ event_type: 8 }) // 埋点，商品分享网页 - 首页浏览次数
    const metaDescription = document.querySelector('meta[name="description"]')
    metaDescription?.setAttribute(
      'content',
      t('探索数以百万计的定制产品满足您的业务需求'),
    )
  })

  useEffect(() => {
    getHomeModule()
    if (searchBarDom.current) {
      setSearchBarHeight(searchBarDom.current.offsetHeight)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [corpInfo.corpId])

  const onSearch = () => {
    navigate(`${routesMap.MarktingSearch}?isHome=1`)
  }

  /*
   * 获取首页模块
   */
  async function getHomeModule() {
    if (corpInfo.corpId === '') return

    const params = {
      corpId,
      publishStatus: 1,
    }

    const [err, res] = await to(corpApi.queryHomeModule(params))

    if (err) return

    // 筛选出已发布的模块
    const modules = (res.data || [])
      .filter((module: any) => module.publishStatus === 1)
      .filter((module: any) => module.type !== 3) // 过滤掉产品模块
      .sort((a: { sort: number }, b: { sort: number }) => a.sort - b.sort)

    if (!modules.length) {
      Toast.show(t('首页模块为空'))
      return
    }

    setModules(modules)
    setIsLoadingProducts(true)
  }

  const renderedModules = modules.map((item: ModuleItemProps) => {
    return (
      <div className={styles['customize-item']} key={item.corpModuleId}>
        {item.type === 0 && <Banner module={item} />}
        {item.type === 1 && <Nav1 module={item} />}
        {item.type === 2 && <Nav2 module={item} />}
        {item.type === 3 && <ProductModule module={item} />}
      </div>
    )
  })

  // 如果第1个模块不是banner模块，则在第1个模块前面插入默认banner图片
  if (modules.length && modules[0].type !== 0) {
    renderedModules.unshift(
      <div className={styles['customize-item']} key="BannerDefault">
        <BannerDefault />
      </div>,
    )
  }

  const bannerModule = renderedModules.shift()

  return (
    <div className={styles['home-wrap']}>
      {/* 头部，包含搜索栏、模块1 */}
      <div className={styles['home-header']}>
        {/* 搜索栏 */}
        <div className={styles['searchbar-box']} ref={searchBarDom}>
          <SearchBar
            className={styles['search-bar']}
            customizeStyle={{ backgroundColor: 'white' }}
            onSearch={onSearch}
            isShowScan={false}
          />
        </div>

        {/* 模块1 */}
        {bannerModule}
      </div>

      <div
        className={styles['home-bd']}
        style={{ maxHeight: `calc(100vh - ${searchBarHeight}px` }}
      >
        <div className={styles['customize-warp']}>
          {renderedModules.map((item) => item)}

          {isLoadingProducts && (
            <div className={styles['customize-item']}>
              <AllProducts />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Home
